// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cEdm7A4ZAAWf5Vu_gwDQ {\n  padding-inline-start: 8px;\n}\n\n.BX9fNkRAbXChci2Sb9l3:focus-visible {\n  outline: var(--kobo-focus-ring);\n  outline-offset: var(--kobo-focus-ring-offset);\n}\n", "",{"version":3,"sources":["webpack://./jsapp/js/theme/kobo/Checkbox.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C","sourcesContent":[".label {\n  padding-inline-start: 8px;\n}\n\n.input:focus-visible {\n  outline: var(--kobo-focus-ring);\n  outline-offset: var(--kobo-focus-ring-offset);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": "cEdm7A4ZAAWf5Vu_gwDQ",
	"input": "BX9fNkRAbXChci2Sb9l3"
};
export default ___CSS_LOADER_EXPORT___;
